interface Comment {
  avatar: string;
  name: string;
  time: string;
  content: string;
  likes: number;
  tag: string;
}

const comments: Comment[] = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20picture%20of%20a%20young%20Chinese%20person%20with%20trendy%20style%2C%20neutral%20expression%2C%20minimal%20portrait%20photography%20with%20soft%20lighting%20on%20light%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜一线战士',
    time: '2分钟前',
    content: '这个料太劲爆了！我就说之前看那个综艺的时候就感觉不对，果然有内幕。坐等后续更新，已收藏页面。',
    likes: 328,
    tag: '娱乐圈',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20picture%20of%20an%20Asian%20woman%20with%20casual%20style%2C%20friendly%20smile%2C%20clean%20portrait%20photography%20with%20natural%20daylight%20on%20neutral%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '不吃到瓜不睡觉',
    time: '15分钟前',
    content: '终于有人把这件事说清楚了！之前看了好几个版本都云里雾里的，这篇梳理得太清晰了。已转发给姐妹们一起吃瓜🍉',
    likes: 256,
    tag: '网曝门事件',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20picture%20of%20a%20Chinese%20man%20with%20stylish%20glasses%2C%20professional%20yet%20casual%20look%2C%20headshot%20portrait%20with%20soft%20studio%20lighting%20on%20cream%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '真相调查员',
    time: '32分钟前',
    content: '理性吃瓜，不要站队太快。等各方都发声了再做判断。不过这篇文章整理的事实确实很全面，给小编加鸡腿。',
    likes: 189,
    tag: '今日黑料',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20picture%20of%20a%20young%20Asian%20woman%20with%20long%20hair%2C%20warm%20expression%2C%20close-up%20portrait%20photography%20with%20soft%20warm%20tone%20lighting%20on%20light%20beige%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '八卦小能手',
    time: '45分钟前',
    content: '51吃瓜现在是我每天必刷的网站了，更新速度真的快！今天这个录音事件我在这第一时间看到的。',
    likes: 412,
    tag: '独家猛料',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20picture%20of%20a%20Chinese%20person%20with%20modern%20casual%20look%2C%20confident%20expression%2C%20editorial%20portrait%20photography%20with%20dramatic%20lighting%20on%20neutral%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '深夜吃瓜人',
    time: '1小时前',
    content: '这个平台的信息质量确实比很多社交媒体的碎片化信息强多了。每条爆料都有来龙去脉，不是单纯的标题党。',
    likes: 175,
    tag: '最新内幕',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            看看吃瓜群众们都在讨论什么
          </p>
        </div>

        <div className="space-y-4">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="flex gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex-shrink-0">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="font-semibold text-foreground-900 text-sm">{comment.name}</span>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-accent-100 text-accent-700">
                    {comment.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed mb-2">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}